<template>

  <rpm-table
      title="Organizações"
      :columns="columns"
      :data="organizations"
      :pagination="pagination"
      :loading="tableDataIsLoading"
      @change-page="getOrganizations"
  >
    <template #functions>
      <section class="flex flex-row-reverse w-full">
        <rpm-button
            class="w-6 h-6 rounded"
            font-size="text-sm"
            icon="fa-solid fa-plus"
            @click="openModal({})"
        ></rpm-button>
      </section>
    </template>

    <template #actions="{ item }">
      <rpm-button
        icon="fa-solid fa-pen-to-square"
        color="transparent"
        tooltip-text="editar"
        @click="openModal(item)"
      ></rpm-button>

      <rpm-button
        v-if="item.enabled"

        icon="fa-solid fa-eye-slash"
        color="transparent"
        tooltip-text="desativar"
        @click="item.enabled = false"
      ></rpm-button>

      <rpm-button
        v-else

        icon="fa-solid fa-eye"
        color="transparent"
        tooltip-text="ativar"
        @click="item.enabled = true"
      ></rpm-button>
    </template>
  </rpm-table>


  <rpm-modal
    :header="this.organizationForm.id ? 'Atualizar Organização':'Criar Organização'"
    class="flex flex-col gap-y-8"
    persist
    :open="modalOpen"
    @close="modalOpen = false"
  >

    <section class="flex flex-col gap-6">

      <rpm-input
        v-model="organizationForm.name"
        :errors="errors.name"
        label="Nome"
        required
        placeholder="Nome da organização"
      ></rpm-input>

      <rpm-input
        v-model="organizationForm.acronym"
        :errors="errors.acronym"
        label="Sigla"
        required
        placeholder="Sigla"
      ></rpm-input>

      <section class="grid md:grid-cols-2 grid-cols-1 gap-6">

        <rpm-input
          type="select"
          v-model="organizationForm.category_id"
          :errors="errors.category_id"
          label="Categoria"
          placeholder="Categoria"
          :options="allOrganizationCategories"
          optionLabel="name"
          optionValue="id"
        ></rpm-input>

        <rpm-input
          type="select"
          v-model="organizationForm.parent_organization_id"
          :errors="errors.parent_organization_id"
          label="Organização Pai"
          placeholder="Organização Pai"
          :options="allOrganizations"
          optionValue="id"
          optionLabel="name"
        ></rpm-input>

      </section>

    </section>

    <template #buttons>
      <rpm-button
        label="Confirmar"
        :loading="loading"
        @click="save"
      ></rpm-button>
    </template>

  </rpm-modal>

</template>


<script>

import RpmTable from "#components/RpmTable.vue";
import Badge from "#components/Badge.vue";
import RpmModal from "#components/RpmModal.vue";
import organizationsRepository from "#repositories/organizationsRepository";
import organizationCategoryRepository from "#repositories/organizationCategoryRepository";
import {request} from "#repositories/repository";
import {getErrors} from "#functions/validator";

export default {
  name: "Organizations",
  components: {
    RpmTable,
    RpmModal,
    Badge
  },
  data() {
    return {
      columns: [
        {
          field: "name",
          label: "Nome",
        },
        {
          field: "acronym",
          label: "Sigla",
        },
        {
          field: "parent",
          label: "Organização pai",
        },
        {
          field: "root",
          label: "Origem",
        },
        {
          field: "enabled",
          label: "Habilitado",
        },
        {
          field: "visible",
          label: "Visível",
        },
      ],
      tableDataIsLoading: true,
      organizations: [],
      allOrganizations: [],
      organizationForm: {},
      allOrganizationCategories: [],
      errors: {},
      pagination: {
        page: this.$route.query.page ?? 1,
        per_page: 12,
        last_page: 0,
        links: []
      },
      modalOpen: false,
      loading: false
    };
  },
  methods: {
    async getOrganizations(page = 0) {
      if (page && page !== 0) this.pagination.page = page;

      this.tableDataIsLoading = true;

      this.organizations = request.pagination(
        await organizationsRepository.getOrganizations(this.pagination),
        this.pagination
      );

      this.tableDataIsLoading = false;
    },
    openModal(item) {
      this.modalOpen = true;
      this.organizationForm = item;
    },
    async fetchAllOrganizations() {
      this.allOrganizations = (await organizationsRepository.getOrganizations()).data
    },
    async save() {
      this.loading = true;
      if(this.organizationForm.id){
        organizationsRepository.updateOrganization(this.organizationForm.id, this.organizationForm).then(() => {
          this.$notify('Organização modificado com sucesso', 'success');
          this.getOrganizations();
          this.modalOpen = false;
        }).catch((response) => {
          getErrors(this.errors, response.errors);
        }).finally(() => {
          this.loading = false;
        });
      }else{
        this.organizationForm.enabled = true;
        this.organizationForm.visible = true;
        this.organizationForm.root = !!this.organizationForm.category_id;
        organizationsRepository.storeOrganization(this.organizationForm).then(() => {
          this.$notify('Organização criada com sucesso', 'success');
          this.getOrganizations();
          this.modalOpen = false;
        }).catch((response) => {
          getErrors(this.errors, response.errors);
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    async fetchAllOrganizationCategories(){
      this.allOrganizationCategories = (await organizationCategoryRepository.getOrganizationCategories()).data
    }
  },
  mounted() {
    this.getOrganizations();
    this.fetchAllOrganizations();
    this.fetchAllOrganizationCategories();
  },
};
</script>
